// extracted by mini-css-extract-plugin
export default {"imageContent":"Al-z","modal":"Bl-z"};